import { render, staticRenderFns } from "./PreviousResults.vue?vue&type=template&id=2d65cca5&scoped=true&"
import script from "./PreviousResults.vue?vue&type=script&lang=js&"
export * from "./PreviousResults.vue?vue&type=script&lang=js&"
import style0 from "./PreviousResults.vue?vue&type=style&index=0&id=2d65cca5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d65cca5",
  null
  
)

export default component.exports